import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import { SuccessOk, SuccessCreated } from "configs/statusCode";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import Language from "Enums/Language";
import Select from "react-select";
import CountriesService from "../../../../../services/Admin/CountriesService";

const languages = ["en", "ar", "zh", "ru"];

function ModalForm({
	modal,
	toggle,
	header,
	isAdd,
	editObj,
	parentId,
	Service,
	type,
	placeholder,
	setList,
	setShouldGetData,
}) {
	const [loading, setLoading] = useState(false);
	const [countryError, setCountryError] = useState(true);
	const [countryErrorTouched, setCountryErrorTouched] = useState(false);
	const service = new Service();
	const countriesService = new CountriesService();

	const [formData, setFormData] = useState({
		en: "",
		ar: "",
		ru: "",
		zh: "",
		options: [],
		country_id: "",
	});

	useEffect(() => {
		if (editObj?.id) {
			service.find(editObj?.id).then((res) => {
				if (res && res.status === SuccessOk) {
					setFormData({
						...formData,
						...res.data?.name,
						country_id:
							type === "City"
								? {
										label: res.data?.country?.name?.en,
										value: res.data?.country?.id,
								  }
								: {},
					});
				}
			});
		}

		countriesService.getDropDown().then((res) => {
			const newOptions = res.data.map((item) => {
				return {
					label: item.name.en,
					value: item.id,
				};
			});
			setFormData((data) => ({ ...data, options: [...newOptions] }));
		});
	}, []);

	const handleFieldChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const handleSelectChange = (selectedOption) => {
		setCountryError(false);
		setFormData({ ...formData, country_id: selectedOption });
	};

	const handleValidSubmit = (_, values) => {
		let data = {};
		if (!formData["country_id"]?.value && type === "City") {
			setCountryErrorTouched(true);
			setCountryError(true);
			return;
		}

		setLoading(true);
		if (isAdd) {
			data = {
				name: {
					en: formData.en,
				},
				parent_id: type === "main" ? null : parentId,
			};
			if (type === "City") {
				data.country_id = formData["country_id"]?.value;
			}
			languages.forEach((language) => {
				if (formData[language].length) {
					data.name[language] = formData[language];
				}
			});

			service.create(data).then((res) => {
				if (res && res.status === SuccessCreated) {
					setShouldGetData(true);
					toast.success(header + " Added sucessfully");
					toggle();
				} else {
					setLoading(false);
					toast.error(res);
				}
			});
		} else {
			data = {
				name: {
					en: formData.en,
					ar: formData.ar,
					ru: formData.ru,
					zh: formData.zh,
				},
			};
			if (type === "City") {
				data.country_id = formData["country_id"]?.value;
			}
			service.update(editObj.id, data).then((res) => {
				if (res && res.status === SuccessOk) {
					setList((list) => {
						const updatedList = list.map((item) => {
							if (item.id === editObj.id) {
								return {
									...data,
									status: editObj.status,
									id: editObj.id,
								};
							} else {
								return item;
							}
						});
						return updatedList;
					});
					toast.success(type + " Edited Sucessfully");
					toggle();
					setShouldGetData(true);
				} else {
					setLoading(false);
					toast.error(res);
				}
			});
		}
	};
	return (
		<Modal isOpen={modal} toggle={toggle} className="scrollbar-container mt-5">
			<ModalHeader toggle={toggle}>
				{isAdd ? `Add New ${header} ` : `Update ${header}`}
			</ModalHeader>
			<ModalBody>
				<AvForm
					className="form-horizontal"
					onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
					<Row className="mb-2">
						{Language.LIST.map((lan, index) => {
							return (
								<Col md={6} key={index} className="mb-3">
									<AvField
										name={lan.name}
										label={lan.label}
										bsSize="lg"
										value={formData[`${lan.name}`]}
										onChange={(e) => handleFieldChange(e)}
										placeholder={lan[`${placeholder}`]}
										validate={{
											required: {
												value: lan.name === "en" ? true : false,
												errorMessage: "This Field is required",
											},
											pattern: {
												value:
													lan.name === "en"
														? "/^[A-Za-z ]+$/"
														: lan.name === "ar"
														? "/^[\u0621-\u064A ]+$/"
														: "",
												errorMessage: `${
													lan.name == "en" ? "English" : "Arabic"
												} format is invalid`,
											},
										}}
									/>
								</Col>
							);
						})}
					</Row>
					{type === "City" && (
						<Row>
							<Col md={12}>
								<label>Country</label>
								<Select
									name="country"
									placeholder="eg.. Country"
									options={formData.options}
									className="mb-3 p-1"
									onChange={handleSelectChange}
									onBlur={() => setCountryErrorTouched(true)}
									value={formData.country_id}
								/>
								{countryError && countryErrorTouched && (
									<p className="text-danger">please select country</p>
								)}
							</Col>
						</Row>
					)}
					<ModalFooter className="px-0">
						<button
							disabled={loading ? true : false}
							type="submit"
							size={"lg"}
							className="btn btn-success w-100">
							{isAdd ? `Add ${header}` : `Update ${header}`}
						</button>
					</ModalFooter>
				</AvForm>
			</ModalBody>
		</Modal>
	);
}

export default ModalForm;
